export default "__VITE_ASSET__kAwPKNE7__"